import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {BottomStickyNavbarContainerBox} from "./boxes/bottom-sticky-navbar-container.box";
import {StickyNavigationMenuListComponent} from "./sticky-navigation-menu-list.component";

@observer
export class StickyNavigationMenuComponent extends OrbitComponent<{}> {

  render() {

    if (!this.services.device.hybrid.isEmbedded) {
        return null;
    }

    if (!this.services.mediaQuery.lAndBelow) {
        return null;
    }

    return(
      <BottomStickyNavbarContainerBox shouldElevate={this.services.spinner.isSpinning} >
        <StickyNavigationMenuListComponent />
      </BottomStickyNavbarContainerBox>
    );
  }
}
